import { seoKeywords } from "./seoKeywords";

export const navakailayamSeoPages = [
  {
    keywordId: "navaKailayamTaxi",
    name: seoKeywords.navaKailayamTaxi.h1,
    path: "/taxi-services-in-nava-kailayam-temples",
    canonicalUrl: "https://www.aadvikacabs.com/taxi-services-in-nava-kailayam-temples",
    zone: "Nava Kailayam SEO",
    tagline: seoKeywords.navaKailayamTaxi.metaDescription,
  },
  {
    keywordId: "navaKailayamCab",
    name: seoKeywords.navaKailayamCab.h1,
    path: "/cab-services-in-nava-kailayam-temples",
    canonicalUrl: "https://www.aadvikacabs.com/cab-services-in-nava-kailayam-temples",
    zone: "Nava Kailayam SEO",
    tagline: seoKeywords.navaKailayamCab.metaDescription,
  },
  {
    keywordId: "bookCabNavaKailayam",
    name: seoKeywords.bookCabNavaKailayam.h1,
    path: "/book-cab-in-nava-kailayam-temples",
    canonicalUrl: "https://www.aadvikacabs.com/book-cab-in-nava-kailayam-temples",
    zone: "Nava Kailayam SEO",
    tagline: seoKeywords.bookCabNavaKailayam.metaDescription,
  },
  {
    keywordId: "tirunelveliToNavaKailayamCab",
    name: seoKeywords.tirunelveliToNavaKailayamCab.h1,
    path: "/cab-service-from-tirunelveli-to-nava-kailayam-temples",
    canonicalUrl: "https://www.aadvikacabs.com/cab-service-from-tirunelveli-to-nava-kailayam-temples",
    zone: "Nava Kailayam SEO",
    tagline: seoKeywords.tirunelveliToNavaKailayamCab.metaDescription,
  },
  {
    keywordId: "tirunelveliToNavaKailayamTaxi",
    name: seoKeywords.tirunelveliToNavaKailayamTaxi.h1,
    path: "/taxi-services-from-tirunelveli-to-nava-kailayam-temples",
    canonicalUrl: "https://www.aadvikacabs.com/taxi-services-from-tirunelveli-to-nava-kailayam-temples",
    zone: "Nava Kailayam SEO",
    tagline: seoKeywords.tirunelveliToNavaKailayamTaxi.metaDescription,
  },
  {
    keywordId: "tirunelveliCabServices",
    name: seoKeywords.tirunelveliCabServices.h1,
    path: "/cab-services-in-tirunelveli",
    canonicalUrl: "https://www.aadvikacabs.com/cab-services-in-tirunelveli",
    zone: "City SEO",
    tagline: seoKeywords.tirunelveliCabServices.metaDescription,
  },
  {
    keywordId: "railwayStationCabs",
    name: seoKeywords.railwayStationCabs.h1,
    path: "/tirunelveli-railway-station-taxi-cab-pickup",
    canonicalUrl: "https://www.aadvikacabs.com/tirunelveli-railway-station-taxi-cab-pickup",
    zone: "Pickup SEO",
    tagline: seoKeywords.railwayStationCabs.metaDescription,
  },
  {
    keywordId: "hotelCabs",
    name: seoKeywords.hotelCabs.h1,
    path: "/hotel-pickup-drop-cab-services-tirunelveli",
    canonicalUrl: "https://www.aadvikacabs.com/hotel-pickup-drop-cab-services-tirunelveli",
    zone: "Pickup SEO",
    tagline: seoKeywords.hotelCabs.metaDescription,
  },
];
